/**
 * Where the person was when they pressed Settings, so Back and Esc can take them there. Held in
 * memory only: a reload of a Settings address has no earlier page to remember, and then Back goes
 * to the home screen rather than guessing.
 */
const FALLBACK = "/home";
let target: string | null = null;

export function isSettingsPath(path: string): boolean {
  return path === "/settings" || path.startsWith("/settings/");
}

/** Remembers the page Settings was opened from. Moving about inside Settings never replaces it. */
export function rememberReturnTarget(href: string): void {
  if (!isSettingsPath(href.split(/[?#]/)[0] ?? href)) target = href;
}

export function returnTarget(): string {
  return target ?? FALLBACK;
}

/** For tests: forget everything, as a fresh page load does. */
export function forgetReturnTarget(): void {
  target = null;
}
